import React from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
} from '@material-ui/core';

export default class MultipleInputModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {};
    }

    confirm(){
        this.props.confirmFunction(this.state.enteredText);
        if (this.props.closeOnConfirm) this.props.closeFunction();
    }

    render() {
        const { 
            children, 
            show, 
            contentText,
            closeFunction,
            confirmText,
            confirmDisabled,
        } = this.props;

        return (
            <Dialog
                open={show}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogContent
                    style={{ display: 'flex', flexDirection: 'column' }}
                >
                   <DialogContentText>
                      {contentText}
                   </DialogContentText>
                   {children}
                </DialogContent>
                <DialogActions>
                    <Button 
                        onClick={() => closeFunction()} 
                        className='btnTextInputModalCancel' 
                        color='secondary'
                    >
                        Cancel
                    </Button>
                    <Button
                        disabled={confirmDisabled} 
                        onClick={() => this.confirm()}
                        className='btnTextInputModalConfirm' 
                        color='primary' 
                        variant='contained'
                        autoFocus
                    >
                        {confirmText}
                   </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

MultipleInputModal.defaultProps = {
    closeOnConfirm: true,
    confirmDisabled: false,
};